module.exports = __webpack_public_path__ + "static/media/avatar1.17edecbf.webp";